<span class="modal-close-icon"><i class="fa-regular fa-circle-xmark" (click)="closeModal('dismiss')"></i></span>
<div class="modal-body">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <form [formGroup]="workPlaceForm">
        <div class="mt-5">
          <div class="form-row">
            <div class="col-md-6 mb-3">
              <label for="name">Name</label>
              <input type="text" class="form-control" formControlName="name" id="name" placeholder="Name">
            </div>
            <div class="col-md-6 mb-3">
              <label for="roomName">Room</label>
              <select id="roomName" class="form-control" formControlName="roomName">
                <option *ngFor="let room of rooms" [value]="room.name">{{ room.name }}</option>
              </select>
            </div>
          </div>
          <div class="modal-buttons text-center">
            <button type="button" class="btn btn-default add-edit-button" (click)="closeModal(workPlaceForm)">Save</button>
            <button type="button" class="btn btn-light cancel-button" (click)="closeModal('cancel')">Cancel</button>
          </div>
          <div class="form-row mt-4">
            <div class="alert alert-danger" *ngIf="errorMessage">Error: {{errorMessage}}</div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
